import { apiGet } from '~/_shared/utils/api/api.helpers';

export enum SsoLoginResponseCode {
  Success = 'SUCCESS',
}

export type SsoLoginResponse = Readonly<{
  access_token_expiration: string;
  refresh: string;
  code: SsoLoginResponseCode;
}>;

export const msSsoLogin = ({
  code,
  codeVerifier,
  redirectUri,
  state,
}: {
  code: string;
  codeVerifier: string;
  redirectUri: string;
  state: string;
}): Promise<SsoLoginResponse> => {
  const requestUrl = '/api/microsoft/sso/callback';

  return apiGet(requestUrl, {
    code,
    code_verifier: codeVerifier,
    redirect_uri: redirectUri,
    state,
  });
};

export const googleSsoLogin = ({
  code,
  redirectUri,
  state,
  prompt,
  scope,
}: {
  code: string;
  redirectUri: string;
  state: string;
  prompt: string;
  scope: string;
}): Promise<SsoLoginResponse> => {
  const requestUrl = '/api/google/sso/callback';

  return apiGet(requestUrl, {
    code,
    redirect_uri: redirectUri,
    state,
    prompt,
    scope,
  });
};
